import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { environment } from "src/environments/environment";
import { Router} from "@angular/router";

declare var gtag;
declare var fbq;

@Component({
  selector: 'app-termscondition',
  templateUrl: './termscondition.component.html',
  styleUrls: ['./termscondition.component.css']
})
export class TermsconditionComponent implements OnInit {

  constructor(private service:AppService,private router: Router) { }

  data:any='';
  loader:boolean=false;
  ngOnInit() {
    if(environment.production){
    this.service.sendEvents("Completetermscondition", "termscondition", "TermsCondition");

    fbq('track', "CompleteTermsCondition" , {
      content_type: "termscondition",
      content_title: this.router.url,
    });
  }

    this.service.setTitle('Terms and Conditions | Propira');
    this.service.setMetaTags({ property: "og:title", content: 'Terms and Conditions | Propira' });
    this.service.setMetaTags({ name: "keywords", content: 'Propira Terms and Conditions ' });
    this.service.setMetaTags({ name: "description", content: 'Read terms and conditions on payment terms, submission of listing, use of information, restrictions, etc. ' });
    this.service.setMetaTags({ property: "og:description", content: 'Read terms and conditions on payment terms, submission of listing, use of information, restrictions, etc.' });

    this.loader=true;
    this.service.get('/termsConditionInfo').subscribe(
      data=>{
        if(data[0].error=='0'){
          this.data=data[0].description;
        }
        this.loader=false;
      },error=>{
        this.loader=false;
        console.log('in error');
      }
    )
  } 

}
